import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Button, Modal, Tooltip, Typography, } from 'antd';
import { ExclamationCircleFilled, InfoCircleOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { txt } from 'libs/i18n';
import { useSession } from 'components/Authenticated';
import { fetchApiToken, renewToken } from 'api/user-api';
import styles from './style.module.less';
const { Paragraph } = Typography;
const MASKED_TOKEN = 'beey__APITOKEN********';
const ApiToken = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [apiTokenState, setApiTokenState] = useState({ state: 'empty' });
    const [hasToken, setHasToken] = useState(false);
    const { session } = useSession();
    const hasTokenClaim = session.login.hasClaim('account:apiToken');
    useEffect(() => {
        if (!hasTokenClaim) {
            return;
        }
        const getToken = async () => {
            const response = await fetchApiToken(session.connection);
            if (response.isFail()) {
                setHasToken(false);
            }
            else {
                setHasToken(true);
            }
        };
        void getToken();
    }, []);
    const handleOpenModal = () => {
        setModalOpen(true);
        setApiTokenState({ state: 'empty' });
    };
    const handleCloseModal = () => {
        setModalOpen(false);
    };
    const handleGenerateToken = async () => {
        setApiTokenState({ state: 'loading' });
        const response = await renewToken(session.connection);
        if (response.isFail() === true) {
            const errorMsg = response.err() === 'invalid-api-token'
                ? txt('invalidApiToken')
                : txt('unexpectedError');
            setApiTokenState({ state: 'error', error: errorMsg });
        }
        else {
            setApiTokenState({ state: 'success', token: response.get().apiToken });
            setHasToken(true);
        }
    };
    const renderModalContent = () => {
        if (apiTokenState.state === 'success') {
            return (_jsxs(_Fragment, { children: [_jsx(Alert, { type: "warning", message: txt('generateTokenWarning'), showIcon: true, icon: _jsx(ExclamationCircleFilled, {}), className: styles.warningAlert }), _jsx(Paragraph, { copyable: { tooltips: [txt('copyToClipboard'), txt('textCopied')] }, className: styles.token, children: apiTokenState.token }), _jsx("div", { className: styles.modalFooter, children: _jsx(Button, { type: "primary", onClick: handleCloseModal, children: txt('close') }) })] }));
        }
        return (_jsxs(_Fragment, { children: [_jsx("p", { children: hasToken
                        ? txt('generateTokenConfirmMessage')
                        : txt('generateFirstTokenConfirmMessage') }), apiTokenState.state === 'error' && (_jsx(Alert, { type: "error", message: apiTokenState.error, showIcon: true, closable: true, onClose: () => setApiTokenState({ state: 'empty' }), className: styles.errorAlert })), _jsxs("div", { className: styles.modalFooter, children: [_jsx(Button, { onClick: handleCloseModal, children: txt('cancel') }), _jsx(Button, { type: "primary", loading: apiTokenState.state === 'loading', onClick: handleGenerateToken, children: hasToken ? txt('renewToken') : txt('generateToken') })] })] }));
    };
    if (!hasTokenClaim) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsxs("h4", { children: [txt('apiToken'), ":"] }), !hasToken && (_jsx("p", { className: styles.noToken, children: txt('noApiToken') })), hasToken && (_jsx("div", { className: styles.maskedToken, children: _jsx(Tooltip, { title: txt('existingApiTokenTooltip'), children: _jsxs("span", { children: [MASKED_TOKEN, ' ', _jsx(InfoCircleOutlined, {})] }) }) })), _jsx(Button, { type: "primary", size: "small", onClick: handleOpenModal, children: hasToken ? txt('renewToken') : txt('generateToken') }), _jsx(Modal, { title: hasToken
                    ? txt('renewTokenConfirmTitle')
                    : txt('generateTokenConfirmTitle'), open: modalOpen, onCancel: handleCloseModal, footer: null, width: 600, children: renderModalContent() })] }));
};
export default ApiToken;
